import { slugify } from './format'

/**
 * Ruta de ficha de hotel: `/{locale}/{slug}-{id}.html`
 * Misma convención que SearchCard / BookingCard / CheckoutRecoveryCard.
 */
export function getHotelDetailPath(
  locale: string,
  hotel: { id?: number; name?: string; slug?: string } | null | undefined
): string | null {
  if (!hotel?.id) return null
  const slug = String(hotel.slug || slugify(hotel.name || 'hotel'))
  return `/${locale}/${slug}-${hotel.id}.html`
}
